import React from 'react';

import { useTranslation } from 'react-i18next';

import { Button } from '@shared/components/button';

import * as Styled from './quest-pagination.styled';

type OwnProps = {
	hasMore: boolean;
	isLoading: boolean;
	onLoadMore: () => void;
};

export const QuestPagination = ({ hasMore, isLoading, onLoadMore }: OwnProps) => {
	const { t } = useTranslation('main');

	return (
		<Styled.QuestPaginationContainer>
			{hasMore && (
				<Button color='dark' size='large' onClick={onLoadMore} disabled={isLoading}>
					{t('more')}
				</Button>
			)}
			<Styled.ToTop screenfuls={1} />
		</Styled.QuestPaginationContainer>
	);
};
